/**
 * @file Build-flavour probe.
 *
 * Development-only affordances — configuration warnings, the AI debug overlay —
 * ask this module rather than reading `import.meta.env` directly, so a single
 * guard covers bundlers and the plain-node test runner alike.
 */

/**
 * @returns {boolean} True in a development build (`vite dev`, `vitest`).
 */
export function isDevBuild() {
  try {
    return Boolean(import.meta.env?.DEV);
  } catch {
    return false;
  }
}
